import {Component} from '@angular/core';

@Component({
    selector: 'app-headline-page',
    templateUrl: './headline-page.component.html',
    styles: [],
    standalone: false
})
export class HeadlinePageComponent {
}
